import {
  AvailabilityCalendar,
  type AvailabilityCalendarFormData,
} from '@/components/AvailabilityCalendar';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  NEW_PATIENT_VISIT_DURATION_IN_MINUTES,
  TELEHEALTH_CONTACT_TYPE,
  type TelehealthContactType,
} from '@/lib/constants';

interface RescheduleAppointmentSelectSlotProps {
  startDate: Date;
  endDate: Date;
  licensedInState: string | null;
  onSubmit: (data: AvailabilityCalendarFormData) => void | Promise<void>;
  appointmentTypeId: string;
  contactType: TelehealthContactType;
}

export const RescheduleAppointmentSelectSlot = ({
  startDate,
  endDate,
  licensedInState,
  onSubmit,
  appointmentTypeId,
  contactType,
}: RescheduleAppointmentSelectSlotProps) => {
  const visitKind = contactType === TELEHEALTH_CONTACT_TYPE.PHONE ? 'phone call' : 'video call';

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Schedule a {NEW_PATIENT_VISIT_DURATION_IN_MINUTES} min clinician {visitKind}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <AvailabilityCalendar
          startDate={startDate}
          endDate={endDate}
          licensedInState={licensedInState}
          onSubmit={onSubmit}
          appointmentTypeId={appointmentTypeId}
          contactType={contactType}
        />
      </CardContent>
    </Card>
  );
};
